<template>
  <div>
    <div v-for="(logs, date) in groupedlogs" :key="date">
      <h3>{{ date }}</h3>
      <div v-for="log in logs" :key="log.id">
        <ProductLog :log="log" />
        <hr />
      </div>
    </div>
    <!-- pagination -->
    <div v-if="pagination.totalPages > 1" class="my-2">
      <b-pagination
        v-model="currentPage"
        :total-rows="pagination.totalElements"
        :per-page="pagination.perPage"
        align="center"
        first-number
        last-number
        prev-class="prev-item"
        next-class="next-item"
      >
        <template #prev-text>
          <feather-icon icon="ChevronLeftIcon" size="18" />
        </template>
        <template #next-text>
          <feather-icon icon="ChevronRightIcon" size="18" />
        </template>
      </b-pagination>
    </div>
  </div>
</template>
<script>
import axios from '@/libs/axios'
import { ref, watch } from '@vue/composition-api'

import { formatDate } from '@core/utils/filter'
import { BPagination, BLink } from 'bootstrap-vue'
import ProductLog from './ProductLog.vue'

export default {
  components: {
    BPagination,
    BLink,
    ProductLog ,
  },
  setup() {
    const groupedlogs = ref([])

    const currentPage = ref(1)

    const pagination = ref({
      totalPages: 1,
      totalElements: 0,
      perPage: 25,
    })

    const fetchData = () => {
      axios
        .get('products-history/search', {
          params: {
            pageNumber: currentPage.value - 1,
            pageSize: pagination.value.perPage,
          },
        })
        .then(res => {
          const dates = {}

          currentPage.value = res.data.number + 1
          pagination.value.totalPages = res.data.totalPages
          pagination.value.totalElements = res.data.totalElements
          pagination.value.perPage = res.data.size

          res.data.content.forEach(log => {
            const key = formatDate(log.creationDate)

            if (dates[key]) {
              dates[key].push(log)
            } else {
              dates[key] = [log]
            }
          })

          groupedlogs.value = dates
        })
    }

    fetchData()
    watch(currentPage, fetchData)

    return {
      // Filter
      formatDate,
      pagination,
      currentPage,
      groupedlogs,
    }
  },
}
</script>
<style lang="scss" scoped>
.time {
  margin-right: 8px;
}
</style>

